export enum KeyboardKeys {
  Enter = 'Enter',
  AltT = 'alt + t',
  NavigateForward = 'ctrl + right',
  NavigateBackward = 'ctrl + left',
  NavigateForwardMac = 'command + right',
  NavigateBackwardMac = 'command + left',
}
